import { ArrowRightIcon } from '@app/app/_icons/ArrowRightIcon';
import Link from 'next/link';
import { UrlObject } from 'node:url';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    className?: string;
    onClick?: () => void;
    href?: string | UrlObject;
    icon: ReactNode;
    children: ReactNode;
}

export function HeroButton({ className, onClick, href, icon, children }: Props) {
    const classNames = twMerge(
        'flex items-center gap-4 rounded-md bg-white p-6 shadow transition-shadow hover:shadow-md',
        className,
    );

    if (href != null) {
        return <Link href={href} className={classNames} onClick={onClick}></Link>;
    }

    return (
        <button type={onClick == null ? 'submit' : 'button'} onClick={onClick} className={classNames}>
            {renderContent()}
        </button>
    );

    function renderContent() {
        return (
            <>
                <div className="shrink-0 text-primary-500">{icon}</div>
                <div className="grow">{children}</div>
                <ArrowRightIcon className="size-6 shrink-0 text-primary-500" />
            </>
        );
    }
}
